import React from 'react';
import Contact from './Contact'
import '../assets/css/BannerAnimate.css'

import contact from "../assets/json/contact.json"

export default class Banner extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      greatingPositionX: 0,
      greatingTextWidht: null,
      screenWidth: 0,
      elemenstState: {
        isDisplaySubCover: false,
        isDisplayContacts: false,
        isNavbarBurgerActive: false,
      },
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleScreenSizeChanged)

    let screenWidth = window.screen.width
    setTimeout(() => {
      this.calcGreetingTextPosition(screenWidth)
    },100);

    setTimeout(() => {
      this.setState({elemenstState: {...this.state.elemenstState, isDisplaySubCover:true}})
    }, 4000);

    if (screenWidth > 1024) {
      setTimeout(() => {
        this.setState({elemenstState: {...this.state.elemenstState, isDisplayContacts:true}})
      }, 5000);
    }
  }

  handleClickNavbarBurger = () => {
    this.setState({elemenstState: {...this.state.elemenstState, isNavbarBurgerActive: !this.state.elemenstState.isNavbarBurgerActive}})
  }

  calcGreetingTextPosition = (screenWidth) => {
    let textLongGreating = this.refs.greetingText.getBBox().width
    let positionGreating = (screenWidth / 2) - (textLongGreating / 2)

    this.setState({
      greatingPositionX: positionGreating,
      greatingTextWidht: screenWidth
    })
  }

  handleScreenSizeChanged = () => {
    let screenWidth = window.screen.width
    this.calcGreetingTextPosition(screenWidth)
  }

  render() {
    return (
      <section className={`hero is-fullheight ${this.state.elemenstState.isNavbarBurgerActive? 'is-hero-active' : ''}`} id={ this.props.id }>
        <header className="hero-head animated" id="header" >
          <header className="navbar">
            <div className="container">
              <div className="navbar-brand">
                <span className={`navbar-burger burger ${this.state.elemenstState.isNavbarBurgerActive? 'is-active' : ''}`}
                      data-target="navbarContactsMenu"
                      onClick={this.handleClickNavbarBurger}>
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </div>
              <div id="navbarContactsMenu" className={`navbar-menu ${this.state.elemenstState.isNavbarBurgerActive? 'is-active animated fadeInDown' : ''}`}>
                <div className="navbar-end">
                  <div className="navbar-item">
                    {
                      this.state.elemenstState.isDisplayContacts &&
                      <div className="field is-grouped is-grouped-multiline animated fadeInDown" ref="contacts">
                        {/* <Contact iconSize="m" iconClass="fab fa-lg fa-instagram" link={contact.instagram.value} /> */}
                        {/* <Contact iconSize="m" iconClass="fab fa-lg fa-facebook" link={contact.facebook.value} /> */}
                        <Contact iconSize="m" iconClass="fab fa-lg fa-github" link={contact.github.value} />
                        <Contact iconSize="m" iconClass="fa fa-lg fa-envelope" link={`mailto:${contact.email.value}`} />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </header>
        </header>

        <div className="hero-body is-paddingless is-marginless" id="banner">
          <div className="overlay-bg">
            <div className="container has-text-centered banner-content">
              <div id="welcomeTextWrapper">
                <h1 className="cover-title">
                  <svg width={this.state.greatingTextWidht? this.state.greatingTextWidht.toString() : "100%"} height="60">
                    <text id="text" ref="greetingText" x={ this.state.greatingPositionX.toString() } y="48" fill="none" stroke="black" strokeWidth="1">Peace be up on you</text>
                  </svg>
                </h1>
                {
                  this.state.elemenstState.isDisplaySubCover &&
                  <>
                    <h2 className="cover-subtitle animated slideInUp">I'm Hanif</h2>
                    <a className="scroller animated fadeIn" href="#coverSection">
                      <span className="arrow-scroll"></span>
                      <span className="arrow-scroll"></span>
                      <span className="arrow-scroll"></span>
                      <span className="arrow-scroll"></span>
                      Scroll down
                    </a>
                  </>
                }
              </div>

            </div>
          </div>
        </div>
      </section>
    )
  }
}